import jsPDF from "jspdf";
import logoImage from "../assets/images/logo.png";
import { formatDate } from "./formatDate";

//Generating the acceptance letter for the Internship application

export const generateAcceptanceLetter = (applicantDetails) => {
  const currentDate2 = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const doc = new jsPDF();

  // Header
  const addHeader = () => {
    doc.setFont("Times", "bold");
    doc.setFontSize(14);
    doc.setTextColor(4, 4, 252);

    doc.text("EAST AFRICAN COMMUNITY", doc.internal.pageSize.width / 2, 20, {
      align: "center",
    });

    doc.text("SECRETARIAT", doc.internal.pageSize.width / 2, 26, {
      align: "center",
    });
    const logoWidth = 32;
    const logoHeight = 28;
    const logoX = (doc.internal.pageSize.width - logoWidth) / 2;
    doc.addImage(logoImage, "JPEG/PNG", logoX, 29, logoWidth, logoHeight);

    // Left-side contact details
    doc.setFontSize(8);
    doc.setFont("Times", "normal");
    doc.setTextColor(13, 13, 13);
    doc.text("EAC Close, Afrika Mashariki Road,", 30, 39);
    doc.text("P.O. Box 1096", 30, 43);
    doc.text("ARUSHA, TANZANIA", 30, 47);

    // Right-side contact details
    doc.text("Tel: +255-27-2504253/8", doc.internal.pageSize.width - 35, 38, {
      align: "right",
    });
    doc.text(
      "Fax: +255-27-2504255/2504481",
      doc.internal.pageSize.width - 35,
      43,
      {
        align: "right",
      }
    );
    doc.text("Email: eac@eachq.org", doc.internal.pageSize.width - 35, 47, {
      align: "right",
    });
    doc.text("Web: http://www.eac.int", doc.internal.pageSize.width - 35, 51, {
      align: "right",
    });
  };

  // Add header
  addHeader();

  doc.setFontSize(11);
  doc.setFont("Times", "bold");
  doc.text("Our Ref: F&A/2/2/5", 20, 60);

  doc.text(`Date: ${currentDate2}`, 20, 65);

  // Address block
  doc.text(
    `${applicantDetails?.surname} ${applicantDetails?.firstName} ${applicantDetails?.otherNames},`,
    20,
    75
  );
  doc.text(`${applicantDetails.address},`, 20, 80);
  doc.text(`${applicantDetails.nationality.toUpperCase()}`, 20, 85);
  doc.text(`Telephone: ${applicantDetails?.phoneNumber}`, 20, 92);
  // Body of the letter
  doc.text(
    `Dear ${applicantDetails?.surname} ${applicantDetails?.firstName} ${applicantDetails?.otherNames},`,
    22,
    104
  );

  doc.text(
    "Re: Offer of an Internship at the East African Community Secretariat",
    doc.internal.pageSize.width / 2,
    111,
    {
      align: "center",
    }
  );

  const textWidth = doc.getTextWidth(
    "Re: Offer of an internship at the East African Community Secretariat"
  );
  // Get the starting X coordinate for centering the underline
  const startX = (doc.internal.pageSize.width - textWidth) / 2;
  const yPosition = 111 + 1; // Adjust the yPosition to place the underline just below the text

  doc.line(startX, yPosition, startX + textWidth, yPosition);
  const bodyText = `This is in reference to your internship request application dated ${formatDate(
    applicantDetails.createdAt
  )} received by the East African Community Secretariat.
  
Your Application has been approved and you will be placed under the Department of ${
    applicantDetails.internshipDepartment
  } under the supervision of ${
    applicantDetails.internshipSupervisor
  }. This internship takes effect from ${formatDate(
    applicantDetails.internshipStartDate
  )} and expires on ${formatDate(applicantDetails.internshipEndDate)}.
  
However, you should note that the EAC Secretariat does not offer any form of financial assistance to interns. You will therefore, be responsible for your own upkeep including transportation costs to and from the East African Community Offices during the whole period of the internship. When reporting, please carry along original copies of your identification, academic and medical insurance documents submitted during application for verification.
  
      
    `;

  doc.setFontSize(11);
  doc.setFont("Times", "normal");
  doc.text(bodyText, 20, 120, { maxWidth: doc.internal.pageSize.width - 40 });

  // Signature section
  doc.text(`Yours sincerely,`, 20, 180);
  doc.setFont("Times", "bold");
  doc.text("Grace Odongo,", 20, 195);
  doc.text("Principal Human Resource Officer", 20, 200);

  // Acceptance block for the intern
  const acceptanceText = `I, __________________________________________________________________________,
  
do hereby accept the internship offer dated ${currentDate2} as per the terms and conditions of EAC.`;
  doc.setFont("Times", "normal");
  doc.text(acceptanceText, 20, 210, {
    maxWidth: doc.internal.pageSize.width - 40,
  });
  doc.setFont("Times", "normal");
  doc.text(
    "Signature: ______________________ Date: ______________________",
    20,
    235
  );

  // Save the PDF
  // doc.save(`${applicantDetails?.surname} ${applicantDetails?.firstName} ${applicantDetails?.otherNames}-Internship-offer.pdf`);
  return doc.output("dataurlstring");
};

// Example applicant details object
// const applicantDetails = {
//   name: "Sharon Shile Kileo",
//   address: "P.O. Box 2798",
//   city: "Arusha",
//   country: "Tanzania",
//   applicationDate: "23rd January 2024",
//   department: "Accounts",
//   supervisor: "Principal Accountant",
//   internshipStartDate: "15th July 2024",
//   internshipEndDate: "6th September 2024",
// };

// generateAcceptanceLetter(applicantDetails);
